import { render, staticRenderFns } from "./myLeaves.vue?vue&type=template&id=2f350612&"
import script from "./myLeaves.vue?vue&type=script&lang=js&"
export * from "./myLeaves.vue?vue&type=script&lang=js&"
import style0 from "./myLeaves.vue?vue&type=style&index=0&id=2f350612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports